import create from 'zustand';
import { UserRole } from 'models/user.model';
import { PermissionState } from './permission.type';

const initialState: PermissionState = {
  role: 'ADMIN',
  emails: [],
  input: '',
  errorMessage: '',
};

export const usePermissionStore = create<PermissionState>(() => ({
  ...initialState,
}));

export const updateInputValue = (value: string): void => {
  const morphValue = value.toLowerCase().replace(/\s/g, '');

  if (morphValue.length > 72) {
    return usePermissionStore.setState({
      errorMessage: 'Email address is too long',
      input: morphValue,
    });
  }

  return usePermissionStore.setState({
    input: morphValue,
    errorMessage: !morphValue && '',
  });
};

export const pushEmailToList = (email: string): void => {
  const morphEmail = email.toLowerCase().replace(/\s/g, '');
  const { errorMessage } = usePermissionStore.getState();

  if (errorMessage) {
    return usePermissionStore.setState({});
  }

  if (usePermissionStore.getState().emails.length > 4) {
    return usePermissionStore.setState({
      errorMessage: 'You can add up to 5 emails',
    });
  }

  if (usePermissionStore.getState().emails.includes(morphEmail)) {
    return usePermissionStore.setState({
      errorMessage: 'This email is already in the list',
    });
  }

  return usePermissionStore.setState({
    emails: [...usePermissionStore.getState().emails, morphEmail],
    errorMessage: '',
    input: '',
  });
};

export const removeEmailFromList = (email: string): void => {
  usePermissionStore.setState({
    emails: usePermissionStore.getState().emails.filter((e) => e !== email),
    errorMessage: '',
  });
};

export const updateRole = (role: UserRole): void => {
  usePermissionStore.setState({ role });
};

export const setErrorMessage = (message: string): void => {
  usePermissionStore.setState({ errorMessage: message });
};

export const clearErrorMessage = (): void => {
  usePermissionStore.setState({ errorMessage: '' });
};

export const clearPermissionStore = (): void => {
  usePermissionStore.setState(initialState);
};
